// import React from 'react';

// function HeaderSection() {
//   return (
//     <div className="header-section">
//       <h1 className="main-header"> LiveTrustAnalyzer </h1>
//       {/* <p className="sub-header">
//         Analyze live or uploaded voice samples to detect emotional tone, zeta-score trustworthiness, and alert-level flags  in real time.
//       </p> */}
//     </div>
//   );
// }

// export default HeaderSection;

import React, { useEffect, useRef } from 'react';
import './Welcome.css';

function HeaderSection() {
  const headerRef = useRef();

  useEffect(() => {
    const header = headerRef.current;
    header.classList.add('slide-in');
  }, []);

  return (
    <div className="sticky-wrapper">
      <div ref={headerRef} className="header-section card-effect">
        <h1 className="main-header">LiveTrustAnalyzer</h1>
      </div>
    </div>
  );
}

export default HeaderSection;

